import { Box } from "@mui/material";
import React from "react";

import { ReactComponent as InfoError } from "../../../../../assets/cai/svg/info_red.svg";
import { LightTooltip } from "components/shared/LightTooltip";
import { StyledPerformanceText } from "./styled";
import { Button } from "components/shared";
import { fetchPerformanceScore } from "store/actions/CreativeAI_Revamp/HomeScreen/Editor/editor.actions";
import {
  CreateVariantsState,
  UPDATE_RECOMMENDATION_SELECTION_STATE,
} from "store/types/CreativeAI/Facebook/CreateVariant/createVariant.types";
import { useDispatch, useSelector } from "react-redux";
import { AdAccountState } from "store/types/adaccount";
import { performanceScoreNullState } from "components/CreativeAI_Revamp/shared/PerformanceTooltip/performance.constant";
import { updateRecommendationMetadata } from "store/actions/CreativeAI/Facebook/CreateVariant/createVariant";
import { checkAdType } from "../../utils/common.utils";
import { FBHomeScreenInitialStateType } from "store/types/CreativeAI_Revamp/HomeScreen/homeScreen.types";
import { HashType } from "../../CreateVariants/Editor/Editor.types";
import { PerformanceScoreType } from "store/types/CreativeAI_Revamp/HomeScreen/Editor/editor.types";

export default function ErrorPerformanceScore({
  index,
  hash,
  value,
}: {
  index: number;
  hash: HashType;
  value: string;
}) {
  const dispatch = useDispatch();
  const { recommendationMetaData } = useSelector(
    (state: { createVariantReducer: CreateVariantsState }) =>
      state.createVariantReducer
  );

  const { adAccountsSelection } = useSelector(
    (state: { fbHomeScreenReducer: FBHomeScreenInitialStateType }) =>
      state.fbHomeScreenReducer
  );

  const { createSpec, selectedAd } = useSelector(
    (state: { createVariantReducer: CreateVariantsState | any }) =>
      state.createVariantReducer
  );
  const { BUSINESS_UNIT_BY_ID_DATA } = useSelector(
    (state: { selectCohortReducer: any; MainReducer: any }) => ({
      BUSINESS_UNIT_BY_ID_DATA: state.MainReducer.variantWithId,
    })
  );
  // redux state
  const { selectedBrand } = useSelector(
    (state: { adaccount: AdAccountState }) => state.adaccount
  );

  return (
    <LightTooltip
      title="Something went wrong, couldn't calculate the Performance Score !"
      arrow
      placement="right"
    >
      <Box
        display="flex"
        sx={{
          padding: "0.2em .5em 0.2em 1em",
          background: "rgba(232, 75, 71, 0.1)",
          borderRadius: "7px 0px",
          gap: ".5em",
        }}
        alignItems="center"
        alignSelf="flex-start"
      >
        <StyledPerformanceText color="#E84B47">
          Performance Score:
        </StyledPerformanceText>
        <InfoError />
        <div
          onClick={() => {
            const localRecommendationData = {
              ...recommendationMetaData,
              isEditing: true,
              isDeleting: false,
            };
            localRecommendationData[hash].data[index] = {
              ...localRecommendationData[hash].data[index],
              text: value,
              isLoading: true,
            };

            dispatch(
              updateRecommendationMetadata({
                data: localRecommendationData,
              })
            );

            dispatch(
              fetchPerformanceScore({
                body: {
                  account_id:
                    adAccountsSelection?.selectedAdAccountId as string,
                  ad_type:
                    checkAdType(createSpec) === "link_data"
                      ? "SINGLE_IMAGE_AD"
                      : "VIDEO_AD",
                  ad_id: selectedAd?.id,
                  assets: [
                    {
                      asset_type: hash,
                      asset_text: value,
                    },
                  ],
                  bu_name: BUSINESS_UNIT_BY_ID_DATA?.businessUnit,
                  bu_detail: BUSINESS_UNIT_BY_ID_DATA?.businessUnitDetail,
                  is_bundle: false,
                },
                callback: ({ error, performanceScore, cancel }) => {
                  if (cancel) {
                    localRecommendationData[hash].data[index] = {
                      text: localRecommendationData[hash].data[index]?.text,
                      ...performanceScoreNullState,
                      isFailed: true,
                    };
                    dispatch(
                      updateRecommendationMetadata({
                        data: localRecommendationData,
                      })
                    );
                  }
                  if (error) {
                    localRecommendationData[hash].data[index] = {
                      ...localRecommendationData[hash].data[index],
                      isFailed: true,
                    };
                  } else {
                    localRecommendationData[hash].data[index] = {
                      ...localRecommendationData[hash].data[index],
                      ...(performanceScore as PerformanceScoreType[])?.[0],
                    };
                    delete localRecommendationData[hash].data[index]?.isFailed;
                  }
                  delete localRecommendationData[hash].data[index]?.isLoading;
                  dispatch(
                    updateRecommendationMetadata({
                      data: localRecommendationData,
                    })
                  );
                  dispatch({
                    type: UPDATE_RECOMMENDATION_SELECTION_STATE,
                    payload: {
                      isChanged: true,
                    },
                  });
                },
              })
            );
          }}
          style={{
            fontFamily: "Inter",
            fontStyle: "italic",
            fontWeight: 500,
            fontSize: "0.625em",
            lineHeight: "20px",
            color: "#0869FB",
            textDecorationLine: "underline",
            cursor: "pointer",
          }}
        >
          Retry
        </div>
      </Box>
    </LightTooltip>
  );
}
